import React, { Component } from 'react';
import GuildProposal from './GuildProposal.js';

class NewMemberRequests extends Component {
    constructor(props) {
        super(props);

        this.state = {
            requests: {},
        };

        this.fetchRequests();
    }

    async fetchRequests() {
        let guildIds = await this.props.ethereum.guilds.getNewMemberRequests();
        let guilds = {};
        for (let i in guildIds) {
            let guildId = guildIds[i].guildId;
            let requester = guildIds[i].requester;
            let userName = await this.props.ethereum.users.getUserName(requester);
            let guildName = await this.props.ethereum.guilds.getGuildName(guildId);
            guilds[guildId] = {guildName: guildName, userName: userName, blockNumber: guildIds[i].blockNumber};
        }
        this.setState({requests: guilds});
    }

    removeRequest(guildId) {
        let requests = {};
        for (let i in this.state.requests) {
            if (i !== guildId) {
                requests[i] = this.state.requests[i];
            }
        }

        this.setState({requests: requests});
    }

    removeProposal(i) {
        let proposals = [... this.state.proposals];
        proposals.splice(i, 1);
        this.setState({proposals: proposals});
    }

    render() {
        if (Object.keys(this.state.requests).length === 0) {
            return (
                <div></div>
            );
        }
        return (
            <div className="link-requests">
              <div className="requests-header">
                Actions to Take
              </div>
             {Object.keys(this.state.requests).map(
                  guildId =>
                      <NewMemberRequest
                            onAccept={(x) => this.removeRequest(guildId)}
                            onReject={(x) => this.removeRequest(guildId)}
                            ethereum={this.props.ethereum}
                            guildId={guildId}
                            guildName={this.state.requests[guildId].guildName}
                            blockNumber={this.state.requests[guildId].blockNumber}
                            userName={this.state.requests[guildId].userName}/>)}
            </div>
        );
    }
}

class NewMemberRequest extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: '',
        };

        this.fetchDate();
    }

    async fetchDate() {
        let block = await this.props.ethereum.web3.eth.getBlock(this.props.blockNumber);
        let date = new Date(block.timestamp * 1000).toLocaleString();
        this.setState({date: date});
    }

    accept() {
        this.props.ethereum.guilds.acceptRequestToAddToGuild(this.props.guildId);
        this.props.onAccept();
    }

    reject() {
        this.props.ethereum.guilds.rejectRequestToAddToGuild(this.props.guildId);
        this.props.onReject();
    }

    render() {
        return (
            <div className="new-member-request">
              <div className="user-field">
                <a className="user-hyperlink" href={"/user/" + this.props.userName}>{this.props.userName}</a>
              </div>
              <div className="action-description">
                requested to add you to {this.props.guildName}
              </div>
              <span className="action-date">{this.state.date}</span>
              <div className="action-btns">
                <div
                  onClick={() => this.accept()}
                  className="common-button pink-button">ACCEPT</div>
                <div
                  onClick={() => this.reject()}
                  className="common-button pink-button">REJECT</div>
              </div>
            </div>
        );
    }
}

export default NewMemberRequests;
